(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["fd-header-search"] && !Shopify.designMode) return;
  try {
    (()=>{
    if(window.FDHeaderSearch)return;
    window.FDHeaderSearch=true;
    let observer;
    function start(){
      const header=document.querySelector('.header-section');
      const template=document.getElementById('fd-header-search-template');
      if(!header||!template||header.querySelector('[data-fd-header-search]'))return;
      observer?.disconnect();
      const bar=template.content.firstElementChild.cloneNode(true);
      header.append(bar);
      let shown=false;
      function sync(){
        const next=header.classList.contains('fd-stuck')&&!header.classList.contains('fd-hidden')&&(window.scrollY||0)>140;
        if(next===shown)return;
        shown=next;
        bar.dataset.open=String(next);
        bar.inert=!next;
        bar.setAttribute('aria-hidden',String(!next));
        document.documentElement.style.setProperty('--fd-header-search-height',next?'60px':'0px');
      }
      observer=new MutationObserver(sync);
      observer.observe(header,{attributes:true,attributeFilter:['class']});
      sync();
    }
    if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
    document.addEventListener('shopify:section:load',start);
    window.addEventListener('pageshow',start);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["fd-home-swipe"] && !Shopify.designMode) return;
  try {
    (()=>{
  if(window.FDHomeSwipe)return;
  const instances=new WeakMap();
  const reduced=matchMedia('(prefers-reduced-motion:reduce)');
  let serial=0;
  const arrow=direction=>'<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="'+(direction==='next'?'m9 5 7 7-7 7':'m15 5-7 7 7 7')+'" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  function enhance(track,labels){
    if(instances.has(track))return;
    const products=track.classList.contains('fdgc-bsrow');
    const hintText=labels[products?'products':track.classList.contains('fdgc-row')?'clubs':'nations'];
    const heading=track.previousElementSibling;
    if(!heading?.matches('.fdgc-head,.fdgc-bshead'))return;
    const shell=document.createElement('div');shell.className='fd-swipe-shell';
    if(products)shell.classList.add('fd-archive-carousel');
    const retro=products&&!!track.closest('.fdgr-wrap');
    track.before(shell);
    const copy=document.createElement('div');copy.className='fd-swipe-heading-copy';copy.append(...Array.from(heading.childNodes));heading.append(copy);heading.classList.add('fd-swipe-heading');
    const hint=document.createElement('span');hint.className='fd-swipe-hint';hint.textContent=hintText;if(!products)copy.append(hint);
    const navigation=document.createElement('div');navigation.className='fd-swipe-navigation';heading.append(navigation);
    const surface=document.createElement('div');surface.className='fd-swipe-surface';surface.append(track);shell.append(heading,surface);
    let edgeNext=null;
    if(track.classList.contains('fdgc-row')){
      edgeNext=document.createElement('button');
      edgeNext.type='button';edgeNext.className='fd-swipe-edge-next';edgeNext.setAttribute('aria-label',labels.next);
      edgeNext.setAttribute('aria-controls',track.id||'');edgeNext.innerHTML=arrow('next');surface.append(edgeNext);
    }
    const prev=document.createElement('button'),next=document.createElement('button');
    if(!track.id)track.id='fd-home-swipe-'+(++serial);
    track.tabIndex=0;track.setAttribute('role','group');track.setAttribute('aria-label',(heading.querySelector('h3')?.textContent||hintText)+' — '+labels.carousel);
    [prev,next].forEach((button,index)=>{
      const direction=index?'next':'previous';
      button.type='button';button.className='fd-swipe-button';button.setAttribute('aria-label',labels[direction]);button.setAttribute('aria-controls',track.id);
      button.setAttribute(index?'data-fd-swipe-next':'data-fd-swipe-prev','');button.innerHTML=arrow(index?'next':'previous');navigation.append(button);
    });
    const meter=document.createElement('div');meter.className='fd-swipe-meter';meter.setAttribute('aria-hidden','true');
    const fill=document.createElement('span');meter.append(fill);shell.append(meter);
    const counter=document.createElement('span');counter.className='fd-archive-counter';counter.setAttribute('aria-hidden','true');
    if(products){
      surface.append(navigation);const controls=document.createElement('div');controls.className='fd-archive-controls';controls.append(meter,counter);shell.append(controls);
      const all=heading.querySelector('.fdgc-bsall');if(all)all.textContent=labels.viewAll+' ↗';
    }
    let selected='all';
    const visibleCards=()=>Array.from(track.children).filter(card=>!card.hidden);
    function filterCards(){
      for(const card of track.children){
        if(selected==='all'){card.hidden=false;continue;}
        let tags=[];try{tags=JSON.parse(card.dataset.fdCardTags||'[]')}catch{}
        const nation=tags.some(tag=>String(tag).normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase()==='selections nationales');
        const club=tags.some(tag=>String(tag).toLowerCase()==='club');
        card.hidden=selected==='nations'?!nation:!club;
      }
    }
    if(retro){
      shell.classList.add('fd-archive-retro');
      const eyebrow=heading.querySelector('.fdgc-bskick');if(eyebrow)eyebrow.textContent=labels.archiveEyebrow;
      const description=document.createElement('p');description.className='fd-archive-description';description.textContent=labels.archiveDescription;copy.append(description);
      const filters=document.createElement('div');filters.className='fd-archive-filters';filters.setAttribute('role','group');filters.setAttribute('aria-label',labels.filterLabel);
      for(const [value,label] of [['all',labels.filterAll],['nations',labels.filterNations],['clubs',labels.filterClubs]]){
        const button=document.createElement('button');button.type='button';button.textContent=label;button.dataset.fdArchiveFilter=value;button.setAttribute('aria-pressed',String(value==='all'));button.setAttribute('aria-controls',track.id);
        button.addEventListener('click',()=>{selected=value;for(const item of filters.children)item.setAttribute('aria-pressed',String(item===button));filterCards();track.scrollTo({left:0,behavior:'instant'});measure();});filters.append(button);
      }
      copy.append(filters);
    }
    let frame=0,geometry={width:1,total:1,max:0,cards:[]};
    function measure(){
      const box=track.getBoundingClientRect(),position=track.scrollLeft;
      geometry.width=track.clientWidth;geometry.total=track.scrollWidth;geometry.max=Math.max(0,geometry.total-geometry.width);
      geometry.cards=visibleCards().filter(card=>card.matches('[data-fd-product-card]')).map(card=>({right:card.getBoundingClientRect().right-box.left+position}));
      update();
    }
    function update(){
      frame=0;
      const {width,total,max,cards}=geometry,position=Math.max(0,track.scrollLeft),overflow=max>2;
      const atStart=!overflow||position<=2,atEnd=!overflow||position>=max-2;
      if(prev.disabled!==atStart)prev.disabled=atStart;if(next.disabled!==atEnd)next.disabled=atEnd;
      if(edgeNext&&edgeNext.hidden!==atEnd)edgeNext.hidden=atEnd;
      if(shell.dataset.fdAtEnd!==String(atEnd))shell.dataset.fdAtEnd=String(atEnd);
      if(shell.dataset.fdAtStart!==String(atStart))shell.dataset.fdAtStart=String(atStart);
      if(hint.hidden===overflow)hint.hidden=!overflow;if(navigation.hidden===overflow)navigation.hidden=!overflow;
      if(meter.hidden!==(!overflow||!products))meter.hidden=!overflow||!products;
      const message=overflow&&atEnd?labels.end:hintText;if(hint.textContent!==message)hint.textContent=message;
      fill.style.transform='scaleX('+Math.min(1,(width+Math.min(position,max))/Math.max(1,total))+')';
      if(products){
        const found=cards.findIndex(card=>card.right>position+30),current=found<0?Math.max(0,cards.length-1):found;
        const text=String(cards.length?current+1:0).padStart(2,'0')+' / '+String(cards.length).padStart(2,'0');
        if(counter.textContent!==text)counter.textContent=text;
      }
    }
    function move(direction){
      const step=products?(visibleCards()[0]?.getBoundingClientRect().width||track.clientWidth*.7)+12:track.clientWidth*.78;
      track.scrollBy({left:direction*step,behavior:reduced.matches?'instant':'smooth'});shell.classList.remove('is-intro');
    }
    const scroll=()=>{if(!frame)frame=requestAnimationFrame(update);if(track.scrollLeft>2)shell.classList.remove('is-intro')};
    const key=event=>{
      if(event.target!==track||!['ArrowLeft','ArrowRight','Home','End'].includes(event.key))return;
      event.preventDefault();
      if(event.key==='Home'||event.key==='End')track.scrollTo({left:event.key==='Home'?0:track.scrollWidth,behavior:reduced.matches?'instant':'smooth'});
      else move(event.key==='ArrowRight'?1:-1);
    };
    prev.addEventListener('click',()=>move(-1));next.addEventListener('click',()=>move(1));if(edgeNext)edgeNext.addEventListener('click',()=>move(1));track.addEventListener('scroll',scroll,{passive:true});track.addEventListener('keydown',key);
    const resize=new ResizeObserver(measure);resize.observe(track);
    const children=new MutationObserver(()=>{if(retro)filterCards();measure();});children.observe(track,{childList:true});
    const appear=new IntersectionObserver(entries=>{
      if(!entries.some(entry=>entry.isIntersecting))return;
      if(!reduced.matches&&track.scrollLeft<2)shell.classList.add('is-intro');appear.disconnect();
    },{threshold:.6});appear.observe(shell);
    instances.set(track,()=>{resize.disconnect();children.disconnect();appear.disconnect();cancelAnimationFrame(frame);track.removeEventListener('scroll',scroll);track.removeEventListener('keydown',key);instances.delete(track)});
    measure();
  }
  function start(root=document){
    root.querySelectorAll('[data-fd-home-swipe-labels]').forEach(config=>{
      let labels;try{labels=JSON.parse(config.textContent)}catch{return}
      const section=config.closest('.shopify-section')||document;
      section.querySelectorAll('.fdgc-row,.fdgn-flags,.fdgc-bsrow').forEach(track=>enhance(track,labels));
    });
  }
  window.FDHomeSwipe={start};
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>start(),{once:true});else start();
  document.addEventListener('shopify:section:load',event=>start(event.target));
  document.addEventListener('shopify:section:unload',event=>event.target.querySelectorAll('.fdgc-row,.fdgn-flags,.fdgc-bsrow').forEach(track=>instances.get(track)?.()));
})();
  } catch(e) { console.error(e); }
})();

})();
